import Response from '../base/Response';
import ServiceBehaviour from '../base/ServiceBehaviour';
import LookupTransaction from '../requests/LookupTransaction';
import LookupContinueTransaction from '../requests/LookupContinueTransaction';
import PaymentTransaction from '../requests/PaymentTransaction';
import SaleTransaction from '../requests/SaleTransaction';
import AuthTransaction from '../requests/AuthTransaction';
import InvalidTransactionTypeException from '../exceptions/InvalidTransactionTypeException';

export default class CardinalAuthentication extends ServiceBehaviour {
	/**
	 * Stored running transaction to prevent duplicates
	 */
	static runningTransaction: Promise<Response> | null = null;

	/**
	 * Allow future transactions to run safely by cleaning the running transaction
	 */
	free() {
		CardinalAuthentication.runningTransaction = null;
	}

	/**
	 * Send an authentication lookup transaction
	 */
	authenticationLookup(transaction: LookupTransaction): Promise<Response> {
		return this.post('api/v2/cardinal/authentication/lookup', transaction);
	}

	/**
	 * Send and validate authentication continue transaction
	 */
	authenticationContinue(transaction: LookupContinueTransaction): Promise<Response> {
		return this.post('api/v2/cardinal/authentication/continue', transaction);
	}

	/**
	 * Send payment transaction by type (Sale/Auth)
	 */
	async retryTransaction(transaction: PaymentTransaction): Promise<Response> {
		await transaction.doBeforeExecute();

		if (CardinalAuthentication.runningTransaction) {
			return CardinalAuthentication.runningTransaction;
		}

		if (!(transaction instanceof SaleTransaction) && !(transaction instanceof AuthTransaction)) {
			this.free();
			throw new InvalidTransactionTypeException('The request payment type is invalid.');
		}

		const url = `api/v2/transaction/${transaction instanceof SaleTransaction ? 'sale' : 'auth'}`;

		CardinalAuthentication.runningTransaction = this.post(url, transaction).finally(this.free);
		return CardinalAuthentication.runningTransaction;
	}
}
